<template>
  <div
    class="bg-gray-50 shadow px-4 py-5 sm:rounded sm:p-6 h-full overflow-hidden"
  >
    <div class="container mx-auto">
      <div class="w-full">
        <h1 class="text-lg leading-6 font-medium text-gray-900">
          Create Claims
        </h1>
        <p class="mt-1 text-sm text-gray-500 overflow-hidden overflow-ellipsis">
          Create claims on your CDL and Matter Case
        </p>
        <p class="text-sm px-3 p-1 text-red-700">
              Important Notice: U.S. Legal Services’ policy regarding Claims requires they be submitted at least every ninety [90] days, and not more than ninety [90] days following the completion of any legal matter for which services have been rendered. Claims aged ninety [90] days or older may be subject to denial. If you have Claims for services rendered to any Member that are aged over ninety [90] days, please submit them via our Attorney Portal by August 1, 2022 to ensure seamless processing and payment.
            </p>
      </div>
      <div class="px-4 py-5 sm:p-2">
        <div class="bg-white shadow overflow-hidden sm:rounded-lg mb-2">
           
          <div
            class="barley-corn-bg-color-3 border-l-4 cobalt-border-color-3 p-4 text-[#1f3341] m-4"
          >
           
            <ul class="list-disc ml-3">
              <li>
                You can submit invoices, as well as view information on your
                submitted invoice. You can view your cases by choosing the case
                type (Matter or CDL), or the status.
              </li>
              <li>
                You can search directly by entering the USL number or the USL
                Member number. Both numbers were provided in the email
                correspondence.
              </li>
            </ul>
          </div>
          <div class="px-4 sm:px-6">
            <fieldset class="mt-4 border-0 p-0 m-0 md:inline-flex items-start">
              <legend class="text-md font-medium text-gray-500 px-0">
                <b>Select Case Type:</b>
              </legend>
              <div class="ml-2">
                <label class="inline-flex items-center">
                  <input
                    type="radio"
                    class="form-radio h-5 w-5 cobalt-text-color"
                    v-model="caseType"
                    name="caseType"
                    @change="search()"
                    value="CDL"
                  />
                  <span class="ml-2">CDL Only </span>
                </label>
                <label class="inline-flex items-center ml-6">
                  <input
                    type="radio"
                    @change="search()"
                    class="form-radio h-5 w-5 cobalt-text-color"
                    v-model="caseType"
                    name="caseType"
                    value="Matter"
                  />
                  <span class="ml-2">Matter Only</span>
                </label>
              </div>
            </fieldset>
            <br />
            <fieldset class="mt-4 border-0 p-0 m-0 md:inline-flex items-start">
              <legend class="text-md font-medium text-gray-500 px-0">
                <b>USL Cases and Claims:</b>
              </legend>
              <div class="ml-2">
                <label class="inline-flex items-center">
                  <input
                    type="radio"
                    class="form-radio h-5 w-5 cobalt-text-color"
                    @change="search()"
                    v-model="caseStatus"
                    name="caseStatus"
                    value="Not Closed"
                  />
                  <span class="ml-2">Un-billed</span>
                </label>
                <label class="inline-flex items-center ml-6">
                  <input
                    type="radio"
                    class="form-radio h-5 w-5 cobalt-text-color"
                    @change="search()"
                    v-model="caseStatus"
                    name="caseStatus"
                    value="In Process"
                  />
                  <span class="ml-2">Billed</span>
                </label>
                <label class="inline-flex items-center ml-6">
                  <input
                    type="radio"
                    class="form-radio h-5 w-5 cobalt-text-color"
                    @change="search()"
                    v-model="caseStatus"
                    name="caseStatus"
                    value="Closed"
                  />
                  <span class="ml-2">Approved/Paid</span>
                </label>
                <label class="inline-flex items-center ml-6">
                  <input
                    type="radio"
                    class="form-radio h-5 w-5 cobalt-text-color"
                    @change="search()"
                    v-model="caseStatus"
                    name="caseStatus"
                    value="Denied"
                  />
                  <span class="ml-2">Denied</span>
                </label>
                <label class="inline-flex items-center ml-6">
                  <input
                    type="radio"
                    class="form-radio h-5 w-5 cobalt-text-color"
                    @change="search()"
                    v-model="caseStatus"
                    name="caseStatus"
                    value="Referral"
                  />
                  <span class="ml-2">Referral</span>
                </label>
              </div>
            </fieldset>
            <hr class="mt-3 mb-2" />
            <div
              class="grid xl:grid-cols-4 md:grid-cols-3 sm:grid-cols-1 gap-4"
            >
              <div>
                <label
                  class="text-sm font-medium text-gray-500"
                  for="case_number"
                >
                  USL No:
                </label>
                <div class="mt-1 relative">
                  <input
                    type="text"
                    v-model="caseNumber"
                    name="case_number"
                    id="case_number"
                    class="shadow-sm border-barley border-gray-300 block w-full sm:text-sm rounded-md"
                    placeholder="USL Number"
                  />
                </div>
              </div>
              <div>
                <label class="text-sm font-medium text-gray-500" for="member">
                  USL Member No:
                </label>
                <div class="mt-1 relative">
                  <input
                    type="text"
                    v-model="member"
                    name="member"
                    id="member"
                    class="shadow-sm border-barley border-gray-300 block w-full sm:text-sm rounded-md"
                    placeholder="USL Member Number"
                  />
                </div>
              </div>
              <div v-if="caseStatus=='Closed'">
                <label
                  class="text-sm font-medium text-gray-500"
                  for="check_number"
                >
                  Check Number
                </label>
                <div class="mt-1 relative">
                  <input
                    type="text"
                    v-model="check_number"
                    name="check_number"
                    id="check_number"
                    class="shadow-sm border-barley border-gray-300 block w-full sm:text-sm rounded-md"
                    placeholder="Check Number"
                  />
                </div>
              </div>
              <div v-if="caseStatus=='Closed'">
                <label
                  class="text-sm font-medium text-gray-500"
                  id="payment_date_label"
                  for="payment_date_input"
                >
                  Payment Date
                </label>
                <div class="mt-1 relative">
                  <flat-pickr
                    id="payment_date"
                    v-model="payment_date"
                    :config="paymentDateConfig"
                    class="w-full text-black border-1 border-barley border-gray-300 rounded py-2 px-4"
                    placeholder="Select date"
                  >
                  </flat-pickr>
                </div>
              </div>
              <div class="mt-5">
                <button
                  type="button"
                  @click="search()"
                  class="mt-3 w-full inline-flex items-center justify-center px-4 py-2 border border-transparent shadow-sm font-medium rounded-md text-white cobalt-button-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                >
                  Search
                </button>
                <button
                  type="button"
                  @click="reset()"
                  class="mt-3 w-full inline-flex items-center justify-center px-4 py-2 border border-[#ba4224] shadow-sm font-medium rounded-md text-[#1f3341] bg-[#ffffff] sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                >
                  Reset
                </button>
              </div>
            </div>
            <div
              class="barley-corn-bg-color-3 border-l-4 cobalt-border-color-3 p-4 text-[#1f3341] mt-5 mb-3"
            >
              <ul class="list-disc ml-3">
                <li>
                  Select the case, then scroll down and complete the claim
                  submission process. Enter the required information and upload
                  the supporting documentation. Once complete, click Submit
                  Invoice.
                </li>
                <li>
                For Matter Claims: If you do not see the member or case in your Un-Billed section, you will need to contact our office for additional authorization. For consultation only claims, please file your claim(s) within 90 days from the date of the consultation to ensure payment on your claim.
                </li>
                <li>
                  <b>Questions?</b>
                  <p>
                    <b>Matter Claims:</b> Please contact
                    claims@uslegalservices.net or (904) 737-3366 if you need
                    assistance in submitting your online matter claim.
                  </p>
                  <p>
                    <b>CDL Claims:</b> contact cdlclaims@uslegalservices.net if
                    you need assistance in submitting your online CDL claim.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="flex flex-col mb-2">
          <div class="sm:-mx-6 lg:-mx-8">
            <div
              class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8 w-full"
            >
              <div
                class="
              shadow
              overflow-auto
              border-b border-gray-200
              sm:rounded-lg
            "
              >
                <fieldset class="border-0 p-0 m-0 min-w-full">
                  <legend class="sr-only">Select a case</legend>
                <DataTable
                  class="min-w-full divide-y divide-gray-200"
                  :value="case_list"
                  :paginator="true"
                  :alwaysShowPaginator="false"
                  :rowsPerPageOptions="[5, 10, 20, 50, 70, 100]"
                  :rows="5"
                  v-if="
                    caseType == 'Matter' &&
                      (caseStatus == 'Not Closed' ||
                        search_screen_flag == 'true')
                  "
                >
                  <template #empty>
                    No Records Found
                  </template>
                  <Column field="number" header="SELECT">
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            <input
                              type="radio"
                              :aria-label="'Select case ' + slotProps.data.number"
                              @click="
                                getCasedetails(
                                  slotProps.data.number,
                                  slotProps.data.case_type,
                                  slotProps.data.auth.claim_id,
                                  slotProps.data.auth.auth_id,
                                  slotProps.data.ap_id
                                )
                              "
                              class="form-radio h-5 w-5 cobalt-text-color"
                              name="selectedCase"
                            />
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column field="number" header="USL No.">
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            {{ slotProps?.data?.number }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column field="number" header="Type">
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            {{ slotProps?.data?.case_type }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column
                    field="number"
                    v-show="caseStatus != 'Not Closed'"
                    header="Claim Status"
                  >
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            {{ slotProps?.data?.status }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column field="number" header="Member">
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            {{ slotProps?.data?.member_name }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column field="number" header="Case Status">
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            {{ slotProps?.data?.case_status }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column field="number" header="Coverage">
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            {{ slotProps?.data?.auth.desc }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column field="number" header="Sub Coverage">
                    <template #body="slotProps">
                      <div class="flex items-center w-full">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            {{ slotProps?.data?.auth.sub_coverage || 'None' }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column field="number" header="Fee Schedule Item">
                    <template #body="slotProps">
                      <div class="flex items-center w-full">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            {{ slotProps?.data?.auth.fee_schedule_item }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                </DataTable>
                <DataTable
                  class="min-w-full divide-y divide-gray-200"
                  :value="case_list"
                  :alwaysShowPaginator="false"
                  :paginator="true"
                  :rowsPerPageOptions="[5, 10, 20, 50, 70, 100]"
                  :rows="5"
                  v-if="
                    caseType == 'Matter' &&
                    caseStatus != 'Not Closed' && caseStatus!='Closed' &&
                      search_screen_flag != 'true'
                  "
                >
                  <template #empty>
                    No Records Found
                  </template>
                  <Column
                    field="number"
                    header="SELECT"
                    headerStyle="width: 10px"
                  >
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            <input
                              type="radio"
                              :aria-label="'Select case ' + slotProps.data.number"
                              @click="
                                getCasedetails(
                                  slotProps.data.number,
                                  slotProps.data.case_type,
                                  slotProps.data.auth.claim_id,
                                  slotProps.data.auth.auth_id,
                                  slotProps.data.ap_id
                                )
                              "
                              class="form-radio h-5 w-5 cobalt-text-color"
                              name="selectedCase"
                            />
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column field="number" header="USL No.">
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            {{ slotProps?.data?.number }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column
                    field="number"
                    v-show="caseStatus != 'Not Closed'"
                    header="Claim Status"
                  >
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            {{ slotProps?.data?.status }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column field="number" header="Case Status">
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            {{ slotProps?.data?.case_status }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column field="number" header="Type">
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            {{ slotProps?.data?.case_type }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column field="number" header="Auth">
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div
                            v-if="slotProps?.data?.auth?.ma_plan_class != ''"
                            class="text-sm font-medium text-gray-900"
                          >
                            {{ slotProps?.data?.auth.auth_id }}
                          </div>
                          <div
                            v-if="slotProps?.data?.auth?.ma_plan_class == ''"
                            class="text-sm font-medium text-gray-900"
                          ></div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column field="number" header="Member">
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            {{ slotProps?.data?.member_name }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column field="number" header="Description">
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div
                            v-if="
                              slotProps?.data?.status != '' &&
                                slotProps?.data?.status != null
                            "
                            class="text-sm font-medium text-gray-900"
                          >
                            {{ slotProps?.data?.violation }}
                          </div>
                          <div
                            v-if="
                              slotProps?.data?.status == '' &&
                                slotProps?.data?.status == null
                            "
                            class="text-sm font-medium text-gray-900"
                          >
                            New
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column field="number" header="Assigned Date">
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            {{ slotProps?.data?.assigned_date }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                </DataTable>
                <DataTable
                  class="min-w-full divide-y divide-gray-200"
                  :value="case_list"
                  :alwaysShowPaginator="false"
                  :paginator="true"
                  :rowsPerPageOptions="[5, 10, 20, 50, 70, 100]"
                  :rows="5"
                  v-if="
                    caseType == 'Matter' &&
                      caseStatus=='Closed' &&
                      search_screen_flag != 'true'
                  "
                >
                  <template #empty>
                    No Records Found
                  </template>
                  <Column
                    field="number"
                    header="SELECT"
                    headerStyle="width: 10px"
                  >
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            <input
                              type="radio"
                              :aria-label="'Select case ' + slotProps.data.number"
                              @click="
                                getCasedetails(
                                  slotProps.data.number,
                                  slotProps.data.case_type,
                                  slotProps.data.auth.claim_id,
                                  slotProps.data.auth.auth_id,
                                  slotProps.data.ap_id
                                )
                              "
                              class="form-radio h-5 w-5 cobalt-text-color"
                              name="selectedCase"
                            />
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column field="type" header="Case Type">
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            {{ slotProps?.data?.case_type }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column field="number" header="USL Case #">
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            {{ slotProps?.data?.number }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column field="case_status" header="Case Status">
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            {{ slotProps?.data?.case_status }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column
                    field="member_name"
                    v-show="caseStatus != 'Not Closed'"
                    header="Member Name"
                  >
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            {{ slotProps?.data?.member_name }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column field="number" header="Auth #">
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div
                            v-if="slotProps?.data?.auth?.ma_plan_class != ''"
                            class="text-sm font-medium text-gray-900"
                          >
                            {{ slotProps?.data?.auth.auth_id }}
                          </div>
                          <div
                            v-if="slotProps?.data?.auth?.ma_plan_class == ''"
                            class="text-sm font-medium text-gray-900"
                          ></div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column field="number" header="Coverage">
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            {{ slotProps?.data?.auth?.desc }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column
                      field="number"
                      v-show="caseStatus != 'Not Closed'"
                      header="Claim #"
                      >
                      <template #body="slotProps">
                        <div class="flex items-center">
                          <div class="ml-2">
                            <div class="text-sm font-medium text-gray-900">
                              {{ slotProps?.data?.auth.claim_id }}
                            </div>
                          </div>
                        </div>
                      </template>
                      </Column>
                  <Column
                      field="number"
                      v-show="caseStatus != 'Not Closed'"
                      header="Attorney Invoice/Claim"
                      >
                      <template #body="slotProps">
                        <div class="flex items-center">
                          <div class="ml-2">
                            <div class="text-sm font-medium text-gray-900">
                              {{ slotProps?.data?.auth?.attorney_invoice_claim }}
                            </div>
                          </div>
                        </div>
                      </template>
                      </Column>
                      <Column
                            field="number"
                            v-show="caseStatus != 'Not Closed'"
                            header="Claim Status"
                            >
                            <template #body="slotProps">
                              <div class="flex items-center">
                                <div class="ml-2">
                                  <div class="text-sm font-medium text-gray-900">
                                    {{ slotProps?.data?.status }}
                                  </div>
                                </div>
                              </div>
                            </template>
                            </Column>
                      <Column
                      field="number"
                      v-show="caseStatus != 'Not Closed'"
                      header="Check #"
                      >
                      <template #body="slotProps">
                        <div class="flex items-center">
                          <div class="ml-2">
                            <div class="text-sm font-medium text-gray-900">
                              {{ slotProps?.data?.auth?.check_number }}
                            </div>
                          </div>
                        </div>
                      </template>
                      </Column>
                      <Column
                      field="number"
                      v-show="caseStatus != 'Not Closed'"
                      header="Paid Date"
                      >
                      <template #body="slotProps">
                        <div class="flex items-center">
                          <div class="ml-2">
                            <div class="text-sm font-medium text-gray-900">
                              {{ slotProps?.data?.auth?.paid_date }}
                            </div>
                          </div>
                        </div>
                      </template>
                      </Column>
                      <Column
                      field="number"
                      v-show="caseStatus != 'Not Closed'"
                      header="Paid Amount"
                      >
                      <template #body="slotProps">
                        <div class="flex items-center">
                          <div class="ml-2">
                            <div class="text-sm font-medium text-gray-900">
                              {{ slotProps?.data?.auth?.paid_amount }}
                            </div>
                          </div>
                        </div>
                      </template>
                      </Column>
                </DataTable>
                <DataTable
                  class="min-w-full divide-y divide-gray-200"
                  :value="case_list"
                  :alwaysShowPaginator="false"
                  :paginator="true"
                  :rowsPerPageOptions="[5, 10, 20, 50, 70, 100]"
                  :rows="5"
                  v-if="caseType == 'CDL' && caseStatus!='Closed'"
                >
                  <template #empty>
                    No Records Found
                  </template>
                  <Column field="number" header="SELECT">
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            <input
                              type="radio"
                              :aria-label="'Select case ' + slotProps.data.number"
                              @click="
                                getCasedetails(
                                  slotProps.data.number,
                                  slotProps.data.case_type,
                                  _,
                                  _,
                                  slotProps.data.ap_id
                                )
                              "
                              class="form-radio h-5 w-5 cobalt-text-color"
                              name="selectedCase"
                            />
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column field="number" header="USL No.">
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            {{ slotProps?.data?.number }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column field="number" header="Claim Status">
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            {{ slotProps?.data?.status }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column field="number" header="Case Status">
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            {{ slotProps?.data?.case_status }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column field="number" header="Type">
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            {{ slotProps?.data?.case_type }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column field="number" header="Auth">
                    <template #body="">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900"></div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column field="number" header="Member">
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            {{ slotProps?.data?.member_name }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column field="number" header="Description">
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div
                            v-if="
                              slotProps?.data?.status != '' &&
                                slotProps?.data?.status != null
                            "
                            class="text-sm font-medium text-gray-900"
                          >
                            {{ slotProps?.data?.violation }}
                          </div>
                          <div
                            v-if="
                              slotProps?.data?.status == '' ||
                                slotProps?.data?.status == null
                            "
                            class="text-sm font-medium text-gray-900"
                          >
                            New
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column field="number" header="Assigned Date">
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            {{ slotProps?.data?.number }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                </DataTable>
                <DataTable
                  class="min-w-full divide-y divide-gray-200"
                  :value="case_list"
                  :alwaysShowPaginator="false"
                  :paginator="true"
                  :rowsPerPageOptions="[5, 10, 20, 50, 70, 100]"
                  :rows="5"
                  v-if="caseType == 'CDL' && caseStatus=='Closed'"
                >
                  <template #empty>
                    No Records Found
                  </template>
                  <Column field="number" header="SELECT">
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            <input
                              type="radio"
                              :aria-label="'Select case ' + slotProps.data.number"
                              @click="
                                getCasedetails(
                                  slotProps.data.number,
                                  slotProps.data.case_type,
                                  _,
                                  _,
                                  slotProps.data.ap_id
                                )
                              "
                              class="form-radio h-5 w-5 cobalt-text-color"
                              name="selectedCase"
                            />
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column field="number" header="Case Type">
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            {{ slotProps?.data?.case_type }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column field="number" header="USL Case #">
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            {{ slotProps?.data?.number }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column field="number" header="Member Name">
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            {{ slotProps?.data?.member_name }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column field="number" header="Citation Description">
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div
                            v-if="
                              slotProps?.data?.status != '' &&
                                slotProps?.data?.status != null
                            "
                            class="text-sm font-medium text-gray-900"
                          >
                            {{ slotProps?.data?.violation }}
                          </div>
                          <div
                            v-if="
                              slotProps?.data?.status == '' ||
                                slotProps?.data?.status == null
                            "
                            class="text-sm font-medium text-gray-900"
                          >
                            New
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column field="number" header="Claim #">
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            {{ slotProps?.data?.ap_id }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column field="number" header="Attorney Invoice/Claim">
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            {{ slotProps?.data?.attorney_invoice_claim }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column field="number" header="Case Status">
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            {{ slotProps?.data?.case_status }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column field="number" header="Check #">
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            {{ slotProps?.data?.check_number }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column field="number" header="Paid Date">
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            {{ slotProps?.data?.check_date }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column field="number" header="Paid Amount">
                    <template #body="slotProps">
                      <div class="flex items-center">
                        <div class="ml-2">
                          <div class="text-sm font-medium text-gray-900">
                            {{ slotProps?.data?.paid_amount }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                </DataTable>
                </fieldset>
              </div>
            </div>
          </div>
        </div>
        <!-- claims list -->
        <div
          v-if="caseType == 'Matter' && case_selected == 'true'"
          class="bg-white shadow overflow-hidden sm:rounded-lg mb-4"
        >
          <div class="px-4 py-5 sm:px-6">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Selected Case Details
            </h3>
          </div>
          <div class="border-t border-gray-200 px-4 py-5 sm:px-6">
            <div class="form-group grid grid-cols-6 gap-6 mt-2">
              <div class="col-span-6 sm:col-span-2">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px "
                  >USL Number</label
                >
                <span class="sm:text-sm"> {{ case_details.number }}</span>
              </div>
              <div class="col-span-6 sm:col-span-2">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px "
                  >Case Type</label
                >
                <span class="sm:text-sm">{{ case_details.case_type }}</span>
              </div>
              <div class="col-span-6 sm:col-span-2">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px "
                  >Case Status</label
                >
                <span
                  v-if="case_details.status == 'Assigned To Attorney'"
                  class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
                  >{{ case_details.status }}</span
                >
                <span
                  v-if="case_details.status == 'Mobile/Web Submission'"
                  class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800"
                  >{{ case_details.status }}</span
                >
                <span
                  v-if="case_details.status == 'Closed'"
                  class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800"
                  >{{ case_details.status }}</span
                >
                <span
                  v-if="case_details.status == 'Void'"
                  class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-indigo-100 text-indigo-800"
                  >{{ case_details.status }}</span
                >
                <span
                  v-if="case_details.status == 'Pending'"
                  class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800"
                  >{{ case_details.status }}</span
                >
                <span
                  v-if="case_details.status == 'Authorized'"
                  class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-purple-100 text-purple-800"
                  >{{ case_details.status }}</span
                >
              </div>
              <div class="col-span-6 sm:col-span-2">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px "
                  >Member</label
                >
                <span class="sm:text-sm"> {{ case_details.member_name }}</span>
              </div>
              <div class="col-span-6 sm:col-span-2">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px "
                  >Company</label
                >
                <span class="sm:text-sm"> {{ case_details.company }}</span>
              </div>
              <div class="col-span-6 sm:col-span-2">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px "
                  >Date Assigned</label
                >
                <span class="sm:text-sm">
                  {{ setDateFormat(case_details.assigned_date) }}</span
                >
              </div>
              <div class="col-span-6 sm:col-span-2">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px "
                  >Coverage</label
                >
                <span class="sm:text-sm"> {{ case_details.m_coverage }}</span>
              </div>
              <div class="col-span-6 sm:col-span-2">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px "
                  >Sub Coverage</label
                >
                <span class="sm:text-sm">
                  {{ case_details.fsi }}</span
                >
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="caseType == 'CDL' && case_selected == 'true'"
          class="bg-white shadow overflow-hidden sm:rounded-lg mb-4"
        >
          <div class="px-4 py-5 sm:px-6">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Selected Case Details
            </h3>
          </div>
          <div class="border-t border-gray-200 px-4 py-5 sm:px-6">
            <div class="form-group grid grid-cols-6 gap-6 mt-2">
              <div class="col-span-6 sm:col-span-2">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px "
                  >USL Number</label
                >
                <span class="sm:text-sm"> {{ case_details.number }}</span>
              </div>
              <div class="col-span-6 sm:col-span-2">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px "
                  >Case Type</label
                >
                <span class="sm:text-sm">{{ case_details.case_type }}</span>
              </div>
              <div class="col-span-6 sm:col-span-2">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px "
                  >Case Status</label
                >
                <span
                  v-if="case_details.status == 'Assigned To Attorney'"
                  class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
                  >{{ case_details.status }}</span
                >
                <span
                  v-if="case_details.status == 'Mobile/Web Submission'"
                  class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800"
                  >{{ case_details.status }}</span
                >
                <span
                  v-if="case_details.status == 'Closed'"
                  class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800"
                  >{{ case_details.status }}</span
                >
                <span
                  v-if="case_details.status == 'Void'"
                  class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-indigo-100 text-indigo-800"
                  >{{ case_details.status }}</span
                >
                <span
                  v-if="case_details.status == 'Pending'"
                  class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800"
                  >{{ case_details.status }}</span
                >
                <span
                  v-if="case_details.status == 'Authorized'"
                  class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-purple-100 text-purple-800"
                  >{{ case_details.status }}</span
                >
              </div>
              <div class="col-span-6 sm:col-span-2">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px "
                  >Member</label
                >
                <span class="sm:text-sm"> {{ case_details.member_name }}</span>
              </div>
              <div class="col-span-6 sm:col-span-2">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px "
                  >Company</label
                >
                <span class="sm:text-sm"> {{ case_details.company }}</span>
              </div>
              <div class="col-span-6 sm:col-span-2">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px "
                  >Date Assigned</label
                >
                <span class="sm:text-sm">
                  {{ setDateFormat(case_details.assigned_date) }}</span
                >
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="caseType == 'CDL' && case_selected == 'true'"
          class="bg-white shadow overflow-hidden sm:rounded-lg mb-4"
        >
          <div class="px-4 py-5 sm:px-6">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Enter Citation Disposition(s) Details
            </h3>
          </div>
          <div v-for="violation in case_details.violations" :key="violation.id">
            <div class="border-t border-gray-200 px-4 py-5 sm:px-6">
              <div class="form-group grid grid-cols-6 gap-6 mt-2">
                <div class="col-span-6 sm:col-span-2">
                  <label
                    class="block text-sm font-medium text-gray-700 sm:mt-px "
                    >Citation Number</label
                  >
                  <input
                    type="text"
                    v-model="violation.citation_number"
                    class="shadow-sm border-barley block w-full sm:text-sm border-gray-300 rounded-md"
                    disabled
                  />
                </div>
                <div class="col-span-6 sm:col-span-2">
                  <label
                    class="block text-sm font-medium text-gray-700 sm:mt-px "
                    >Citation Description</label
                  >
                  <input
                    type="text"
                    v-model="violation.violation"
                    class="shadow-sm border-barley block w-full sm:text-sm border-gray-300 rounded-md"
                    disabled
                  />
                </div>
                <div class="col-span-6 sm:col-span-2">
                  <label
                    class="block text-sm font-medium text-gray-700 sm:mt-px "
                    >Points</label
                  >
                  <input
                    type="text"
                    v-model="violation.issued_state_point"
                    class="shadow-sm border-barley block w-full sm:text-sm border-gray-300 rounded-md"
                    :disabled="
                      caseStatus == 'Closed' ||
                        caseStatus == 'In Process' ||
                        caseStatus == 'Denied'
                    "
                  />
                </div>
                <div class="col-span-6 sm:col-span-2">
                  <label
                    class="block text-sm font-medium text-gray-700 sm:mt-px "
                    >Issued State Final Points</label
                  >
                  <input
                    type="text"
                    v-model="violation.final_point"
                    class="shadow-sm border-barley block w-full sm:text-sm border-gray-300 rounded-md"
                    :disabled="
                      caseStatus == 'Closed' ||
                        caseStatus == 'In Process' ||
                        caseStatus == 'Denied'
                    "
                  />
                </div>
                <div class="col-span-6 sm:col-span-2 dropdown-custom">
                  <label
                    class="block text-sm font-medium text-gray-700 sm:mt-px "
                    >Disposition</label
                  >
                  <DropDown
                    class="h-10 pt-1"
                    appendTo="body"
                    v-model="violation.disposition"
                    :options="disposition_codes"
                    optionLabel="title"
                    optionValue="id"
                    required
                  />
                </div>
                <div class="col-span-6 sm:col-span-2">
                  <label
                    class="block text-sm font-medium text-gray-700 sm:mt-px "
                    >Total Initial Fine Due By Driver</label
                  >
                  <input
                    type="number"
                    v-model="violation.init_fine_amount"
                    class="shadow-sm border-barley block w-full sm:text-sm border-gray-300 rounded-md"
                    :disabled="
                      caseStatus == 'Closed' ||
                        caseStatus == 'In Process' ||
                        caseStatus == 'Denied'
                    "
                  />
                </div>
                <div class="col-span-6 sm:col-span-2">
                  <label
                    class="block text-sm font-medium text-gray-700 sm:mt-px "
                    >Final Fine Amount Due</label
                  >
                  <input
                    type="number"
                    v-on:change="violation.final_total_due_driver=parseInt(violation.total_due_amount)+parseInt(violation.final_court_cost_due)"
                    v-model="violation.total_due_amount"
                    class="shadow-sm border-barley block w-full sm:text-sm border-gray-300 rounded-md"
                    :disabled="
                      caseStatus == 'Closed' ||
                        caseStatus == 'In Process' ||
                        caseStatus == 'Denied'
                    "
                  />
                </div>
                <div class="col-span-6 sm:col-span-2">
                  <label
                    class="block text-sm font-medium text-gray-700 sm:mt-px "
                    >Final Court Cost Due</label
                  >
                  <input
                    type="text"
                    v-on:change="violation.final_total_due_driver=parseInt(violation.total_due_amount)+parseInt(violation.final_court_cost_due)"
                    v-model="violation.final_court_cost_due"
                    class="shadow-sm border-barley block w-full sm:text-sm border-gray-300 rounded-md"
                    :disabled="
                      caseStatus == 'Closed' ||
                        caseStatus == 'In Process' ||
                        caseStatus == 'Denied'
                    "
                  />
                </div>
                <div class="col-span-6 sm:col-span-2">
                  <label
                    class="block text-sm font-medium text-gray-700 sm:mt-px "
                    >Final Total Due by Driver</label
                  >
                  <input
                    type="text"
                    v-model="violation.final_total_due_driver"
                    class="shadow-sm border-barley block w-full sm:text-sm border-gray-300 rounded-md"
                    :disabled="
                      caseStatus == 'Closed' ||
                        caseStatus == 'In Process' ||
                        caseStatus == 'Denied'
                    "
                    readonly
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="caseType == 'Matter' && case_selected == 'true'"
          class="bg-white shadow overflow-hidden sm:rounded-lg mb-4"
        >
          <div class="px-4 py-5 sm:px-6">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Authorization Detail
            </h3>
          </div>
          <div class="border-t border-gray-200 px-4 py-5 sm:px-6">
            <div class="form-group grid grid-cols-6 gap-6 mt-2">
              <div class="col-span-6 sm:col-span-2">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px "
                  >Plan Class</label
                >
                <span class="sm:text-sm">{{ case_details.plan_class }}</span>
              </div>
              <!-- {{ case_details}} -->
              <div class="col-span-6 sm:col-span-2">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px "
                  >Coverage</label
                >
                <span class="sm:text-sm"> {{ case_details.desc }}</span>
              </div>
              <div class="col-span-6 sm:col-span-2">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px "
                  >Sub Coverage</label
                >
                <span class="sm:text-sm">{{ case_details.sub_coverage || 'None' }}</span>
              </div>
              <div class="col-span-6 sm:col-span-2">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px "
                  >Fee Schedule Item</label
                >
                <span class="sm:text-sm">{{ case_details.fee_schedule_item }}</span>
              </div>
              <!-- <div class="col-span-6 sm:col-span-2"  v-if= "case_details.created_date < '2025-06-09'">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px "
                  >Sub Coverage</label
                >
                <span class="sm:text-sm">{{ case_details.fee_schedule_item }}</span>
              </div> -->
              <div class="col-span-6 sm:col-span-2">
                <label
                  class="block text-sm font-medium text-gray-700 sm:mt-px "
                >
                  Authorized Amount</label
                >
                <span class="sm:text-sm">
                  ${{ case_details.authorized_amount }}</span
                >
              </div>
              <div class="col-span-6 sm:col-span-2" v-if="case_details.authorized_miles=='' || case_details.authorized_miles==null">
                <label
                  class="block text-sm font-medium text-gray-700 sm:mt-px "
                >
                  Authorized Hours</label
                >
                <span class="sm:text-sm">
                  {{ case_details.authorized_hours }}</span
                >
              </div>
              <div class="col-span-6 sm:col-span-2" v-if="case_details.authorized_miles!='' && case_details.authorized_miles!=null">
                <label
                  class="block text-sm font-medium text-gray-700 sm:mt-px "
                >
                  Authorized Mileage</label
                >
                <span class="sm:text-sm">
                  {{ case_details.authorized_miles }}</span
                >
              </div>
              <div class="col-span-6 sm:col-span-2">
                <label
                  class="block text-sm font-medium text-gray-700 sm:mt-px "
                >
                  Auth Created</label
                >
                <span class="sm:text-sm">
                  {{ setDateFormat(case_details.created_date) }}</span
                >
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="case_selected == 'true' && claim_details.length > 0"
          class="bg-white shadow overflow-hidden sm:rounded-lg mb-4"
        >
          <div class="px-4 py-5 sm:px-6">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Submitted Claims
            </h3>
          </div>
          <div class="border-t border-gray-200 px-4 py-5 sm:px-6">
            <div>
              <div
                class="
              shadow
              overflow-auto
              border-b border-gray-200
              sm:rounded-lg
            "
              >
                <table class="min-w-full divide-y divide-gray-200">
                  <thead class="bg-[#d9f9f9]">
                    <tr>
                      <th
                        scope="col"
                        class="
                      px-6
                      py-3
                      text-left text-xs
                      font-medium
                      text-[#1f3341]
                      uppercase
                      tracking-wider
                    "
                      >
                        Claim #
                      </th>
                      <th
                        scope="col"
                        class="
                      px-6
                      py-3
                      text-left text-xs
                      font-medium
                      text-[#1f3341]
                      uppercase
                      tracking-wider
                    "
                      >
                        Claim Status
                      </th>
                      <th
                        scope="col"
                        class="
                      px-6
                      py-3
                      text-left text-xs
                      font-medium
                      text-[#1f3341]
                      uppercase
                      tracking-wider
                    "
                      >
                        Claim Amount
                      </th>
                      <th
                        scope="col"
                        class="
                      px-6
                      py-3
                      text-left text-xs
                      font-medium
                      text-[#1f3341]
                      uppercase
                      tracking-wider
                    "
                      >
                        Claim Date
                      </th>
                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                    <tr
                      v-if="
                        claim_details.length == 0 ||
                          claim_details.length == null
                      "
                    >
                      <td
                        class="px-6 py-4 whitespace-nowrap text-center"
                        colspan="4"
                      >
                        <h1>No Record Found</h1>
                      </td>
                    </tr>
                    <tr
                      v-else
                      v-for="claim_detail in claim_details"
                      :key="claim_detail.id"
                    >
                      <td class="px-6 py-4 whitespace-nowrap">
                        <div class="text-sm text-gray-900">
                          {{ claim_detail.claim_number }}
                        </div>
                      </td>
                      <td class="px-6 py-4 whitespace-nowrap">
                        <div class="text-sm text-gray-900">
                          {{ claim_detail.claim_status }}
                        </div>
                      </td>
                      <td class="px-6 py-4 whitespace-nowrap">
                        <div class="text-sm text-gray-900">
                          ${{ claim_detail.claim_amount }}
                        </div>
                      </td>
                      <td class="px-6 py-4 whitespace-nowrap">
                        <div class="text-sm text-gray-900">
                          {{ setDateFormat(claim_detail.created_date) }}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="caseType == 'Matter' && case_selected == 'true'"
          class="bg-white shadow overflow-hidden sm:rounded-lg mb-4"
        >
          <div class="px-4 py-5 sm:px-6">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Enter Claim and Submit
            </h3>
          </div>
          <div class="border-t border-gray-200 px-4 py-5 sm:px-6">
            <div class="form-group grid grid-cols-6 gap-6">
              <div class="col-span-6 sm:col-span-2">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px "
                  >Attorney Invoice/Claim</label
                >
                <input
                  type="text"
                  aria-label="Attorney Invoice/Claim"
                  v-model="matter_data.attorney_invoice_claim"
                  class="shadow-sm border-barley border-gray-300 block w-full sm:text-sm rounded-md"
                  :disabled="
                    (case_details.ticket_type == 'Referral' ||
                      caseStatus == 'Closed' ||
                      caseStatus == 'In Process' ||
                      caseStatus == 'Denied' ||
                      case_details.claim_status != null) &&
                      new_claim_flag != 'true'
                  "
                />
              </div>
              <div class="col-span-6 sm:col-span-2">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px"
                  >Claim Amount<span class="ml-1 text-red-700">*</span></label
                >
                <input
                  type="number"
                  aria-label="Claim Amount"
                  v-model="matter_data.claim_amount"
                  class="shadow-sm border-barley border-gray-300 block w-full sm:text-sm rounded-md"
                  :disabled="
                    (case_details.ticket_type == 'Referral' ||
                      caseStatus == 'Closed' ||
                      caseStatus == 'In Process' ||
                      caseStatus == 'Denied' ||
                      case_details.claim_status != null) &&
                      new_claim_flag != 'true'
                  "
                />
              </div>
              <div class="col-span-6 sm:col-span-2" v-if="case_details.authorized_miles=='' || case_details.authorized_miles==null">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px"
                  >Claim Hours</label
                >
                <input
                  type="number"
                  aria-label="Claim Hours"
                  v-model="matter_data.claim_hours"
                  class="shadow-sm border-barley border-gray-300 block w-full sm:text-sm rounded-md"
                  :disabled="
                    (case_details.ticket_type == 'Referral' ||
                      caseStatus == 'Closed' ||
                      caseStatus == 'In Process' ||
                      caseStatus == 'Denied' ||
                      case_details.claim_status != null) &&
                      new_claim_flag != 'true'
                  "
                />
              </div>
              <div class="col-span-6 sm:col-span-2" v-if="case_details.authorized_miles!='' && case_details.authorized_miles!=null">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px"
                  >Claim Mileage</label
                >
                <input
                  type="number"
                  v-model="matter_data.claim_miles"
                  class="shadow-sm border-barley border-gray-300 block w-full sm:text-sm rounded-md"
                  :disabled="
                  true
                  ||
                    (case_details.ticket_type == 'Referral' ||
                      caseStatus == 'Closed' ||
                      caseStatus == 'In Process' ||
                      caseStatus == 'Denied' ||
                      case_details.claim_status != null) &&
                      new_claim_flag != 'true'
                  "
                />
              </div>
              
                <div  v-if="
                  case_details.claim_status == 'Approved & Paid' &&
                    caseStatus != 'Not Closed'
                " class="col-span-6 sm:col-span-2">
                  <label
                    class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
                    >Paid Date</label
                  >
                  <input
                    type="text"
                    v-model="matter_data.paid_date"
                    class="shadow-sm border-barley border-gray-300 block w-full sm:text-sm rounded-md"
                    :disabled="
                      (caseStatus == 'Closed' ||
                        caseStatus == 'In Process' ||
                        caseStatus == 'Denied' ||
                        case_details.claim_status != null) &&
                        new_claim_flag != 'true'
                    "
                  />
                </div>
                <div  v-if="
                  case_details.claim_status == 'Approved & Paid' &&
                    caseStatus != 'Not Closed'
                " class="col-span-6 sm:col-span-2">
                  <label
                    class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
                    >Check Number</label
                  >
                  <input
                    type="number"
                    v-model="matter_data.check_number"
                    class="shadow-sm border-barley border-gray-300 block w-full sm:text-sm rounded-md"
                    :disabled="
                      (case_details.ticket_type == 'Referral' ||
                        caseStatus == 'Closed' ||
                        caseStatus == 'In Process' ||
                        caseStatus == 'Denied' ||
                        case_details.claim_status != null) &&
                        new_claim_flag != 'true'
                    "
                  />
                </div>
                <div  v-if="
                  case_details.claim_status == 'Approved & Paid' &&
                    caseStatus != 'Not Closed'
                " class="col-span-6 sm:col-span-2">
                  <label
                    class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
                    >Paid Amount</label
                  >
                  <input
                    type="number"
                    v-model="matter_data.paid_amount"
                    class="shadow-sm border-barley border-gray-300 block w-full sm:text-sm rounded-md"
                    :disabled="
                      (case_details.ticket_type == 'Referral' ||
                        caseStatus == 'Closed' ||
                        caseStatus == 'In Process' ||
                        caseStatus == 'Denied' ||
                        case_details.claim_status != null) &&
                        new_claim_flag != 'true'
                    "
                  />
                </div>
              
              <div class="col-span-6 sm:col-span-2">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px"
                  >Notes<span class="ml-1 text-red-700">*</span></label
                >
                <textarea
                aria-label="Notes"
                v-if="caseStatus == 'Not Closed'"
                  v-model="matter_data.note"
                  class="max-w-lg shadow-sm block w-full border-barley border-gray-300 sm:text-sm border rounded-md"
                  :disabled="
                    (case_details.ticket_type == 'Referral' ||
                      caseStatus == 'Closed' ||
                      caseStatus == 'In Process' ||
                      caseStatus == 'Denied' ||
                      case_details.claim_status != null) &&
                      new_claim_flag != 'true'
                  "
                ></textarea>
                <textarea
                v-if="caseStatus != 'Not Closed'"
                  v-model="matter_data.attorney_note"
                  class="max-w-lg shadow-sm block w-full border-barley border-gray-300 sm:text-sm border rounded-md"
                  :disabled="
                    (case_details.ticket_type == 'Referral' ||
                      caseStatus == 'Closed' ||
                      caseStatus == 'In Process' ||
                      caseStatus == 'Denied' ||
                      case_details.claim_status != null) &&
                      new_claim_flag != 'true'
                  "
                ></textarea>
              </div>
              <div class="col-span-6 sm:col-span-2">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px"
                  >County/Civil/Criminal Case No</label
                >
                <input
                  type="text"
                  aria-label="County/Civil/Criminal Case No"
                  v-model="matter_data.county_civil_criminal"
                  class="shadow-sm border-barley border-gray-300 block w-full sm:text-sm rounded-md"
                  :disabled="
                    case_details.ticket_type == 'Referral' ||
                      caseStatus == 'Closed' ||
                      caseStatus == 'In Process' ||
                      caseStatus == 'Denied' ||
                      case_details.claim_status != null
                  "
                />
              </div>
              <div class="col-span-6 sm:col-span-2">
                <label
                  class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
                  >Member First Contact Date<span class="ml-1 text-red-700"
                    >*</span
                  ></label
                >
                <flat-pickr
                  v-model="matter_data.payment_date"
                  aria-label="Member First Contact Date"
                  :config="config"
                  class="w-full text-black border-1 border-barley border-gray-300 rounded py-2 px-4"
                  :disabled="
                    (case_details.ticket_type == 'Referral' ||
                      caseStatus == 'Closed' ||
                      caseStatus == 'In Process' ||
                      caseStatus == 'Denied' ||
                      case_details.claim_status != null) &&
                      new_claim_flag != 'true'
                  "
                  placeholder="Select date"
                >
                </flat-pickr>
              </div>
              <div class="col-start-1 col-end-6 col-span-6 sm:col-span-2">
                <label
                  class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
                  >Date of Last Service<span class="ml-1 text-red-700"
                    >*</span
                  ></label
                >
                <flat-pickr
                  v-model="matter_data.date_of_last_service"
                  aria-label="Date of Last Service"
                  :config="config"
                  class="w-full text-black border-1 border-barley border-gray-300 rounded py-2 px-4"
                  :disabled="
                    (case_details.ticket_type == 'Referral' ||
                      caseStatus == 'Closed' ||
                      caseStatus == 'In Process' ||
                      caseStatus == 'Denied' ||
                      case_details.claim_status != null) &&
                      new_claim_flag != 'true'
                  "
                  placeholder="Select date"
                >
                </flat-pickr>
              </div>
              <div class="col-span-6 sm:col-span-2">
                <label
                  class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
                  >Digital Signature (Enter Name)<span class="ml-1 text-red-700"
                    >*</span
                  ></label
                >
                <input
                  type="text"
                  aria-label="Digital Signature (Enter Name)"
                  v-model="matter_data.digital_sign"
                  class="shadow-sm border-barley border-gray-300 block w-full sm:text-sm rounded-md"
                  :disabled="
                    (case_details.ticket_type == 'Referral' ||
                      caseStatus == 'Closed' ||
                      caseStatus == 'In Process' ||
                      caseStatus == 'Denied' ||
                      case_details.claim_status != null) &&
                      new_claim_flag != 'true'
                  "
                />
              </div>
              <div class="col-span-6 sm:col-span-2">
                <label
                  class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
                  >Date<span class="ml-1 text-red-700">*</span></label
                >
                <flat-pickr
                  v-model="matter_data.date"
                  aria-label="Date"
                  :config="config"
                  class="w-full text-black border-1 border-barley border-gray-300 rounded py-2 px-4"
                  :disabled="
                    (case_details.ticket_type == 'Referral' ||
                      caseStatus == 'Closed' ||
                      caseStatus == 'In Process' ||
                      caseStatus == 'Denied' ||
                      case_details.claim_status != null) &&
                      new_claim_flag != 'true'
                  "
                  placeholder="Select date"
                >
                </flat-pickr>
              </div>
              <p class="text-sm px-3 p-1 text-red-700 w-full col-span-6 sm:col-span-6" v-show="caseStatus == 'Not Closed'">
                Please upload each document specified below. The documents with a red asterisk are required to submit the claim.
              </p>
              <div v-for="(file, i) in claim_files" :key="i" v-show="caseStatus == 'Not Closed' && case_details[i]?.show==true">
                <div class="col-span-6 sm:col-span-2">
                  <label
                    for="cover-photo"
                    class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2 w-full mb-1"
                  >
                    {{ file.label }}<span v-if="case_details[i]?.required == true" class="ml-1 text-red-700">*</span>
                  </label>

                  <div
                    class="max-w-lg flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md"
                  >
                    <div class="space-y-1 text-center">
                      <svg
                        class="mx-auto h-12 w-12 text-gray-400"
                        stroke="currentColor"
                        fill="none"
                        viewBox="0 0 48 48"
                        aria-hidden="true"
                      >
                        <path
                          d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <div class="flex text-sm text-gray-600">
                        <!-- <input
                            name="file"
                            @change="uploadMatterFiles($event,i,file.prefix)"
                            type="file"
                            :required="case_details.[i].required"
                            
                            multiple
                          /> -->
                          <label :for="'file-upload '+i" class="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
                            <span>Upload a file</span>
                            <input :id="'file-upload '+i" @change="uploadMatterFiles($event,i,file.prefix)" :name="i" type="file" class="sr-only" multiple/>
                          </label>
                          <p class="pl-1">or drag and drop</p>
                          
                          <!-- class="sr-only" -->
                        <!-- <label
                          for="file"
                          class="relative cursor-pointer bg-white rounded-md font-medium cobalt-text-color hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500"
                        >
                          <span>Upload a file {{i}}</span>
                          
                        </label>
                        <p class="pl-1">or drag and drop</p> -->
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-span-6 sm:col-span-2" v-if="caseStatus == 'Not Closed'">
                    <div class="" v-if="file.files?.length > 0">
                    <div class="" v-for="(pdf, ind) in file.files" :key="ind">
                      <div class="py-5 px-3">
                        <div class="float-left mr-2" align="center">
                          <img src="@/assets/Images/file-pdf.png" />
                        </div>
                        <div class="float-left w-100">
                          <span class="">{{ pdf }}</span>
                        </div>
                      </div>
                      <br />
                      <hr />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="mt-4"
              v-show="caseStatus == 'Not Closed' && matter_save_btn"
            >
              <button
                type="button"
                @click="addPayment()"
                class="mt-3
              w-full
              inline-flex
              items-center
              justify-center
              px-4
              py-2
              border border-transparent
              shadow-sm
              font-medium
              rounded-md
              text-white
             cobalt-button-color
              focus:outline-none
              focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500
              sm:mt-0
              sm:ml-3
              sm:w-auto
              sm:text-sm"
              >
                Submit Claim
              </button>
              <button
                type="button"
                @click="reset()"
                class="mt-3 w-full inline-flex items-center justify-center px-4 py-2 border border-[#ba4224] shadow-sm font-medium rounded-md text-[#1f3341] bg-[#ffffff] sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
              >
                Clear
              </button>
            </div>
            <div
              class="barley-corn-bg-color-3 border-l-4 cobalt-border-color-3 p-4 text-[#1f3341] m-2"
            >
              <ul class="list-disc ml-3">
                <li>
                  <b>ATTORNEY'S DIGITAL SIGNATURE: </b> Network Attorney acknowledges that U.S. Legal Services has been contacted to ascertain the plan benefits available to each Plan Member and obtain the appropriate authorization prior to providing legal services. Additionally, Network Attorney agrees to submit claims every ninety [90] days for ongoing legal matters and not more than ninety [90] days following the completion of any legal matter for which services have been rendered. Network Attorney agrees to maintain appropriate Plan Member records concerning the subject on which advice was given or representation offered or provided, the length of any conferences, the amount of time spent by the Network Attorney in providing advice or representation, the disposition of the matter, and any charges made to the eligible Plan Member for legal services other than Covered services. Network Attorney agrees to make such records available to USL as supporting documentation for claims submitted at reasonable times.
                </li>
                <li>
                  Claim Fraud Warning Statement: Any person who, with intent to
                  defraud or knowing that he or she is facilitating a fraud
                  against an insurer, submits an application or files a claim
                  containing a false or deceptive statement, may be guilty of
                  insurance fraud.
                </li>
                <li>
                  By submitting this claim, I attest to the accuracy of the
                  information submitted and agree to provide additional
                  information necessary to adjudicate this claim. By submitting
                  this claim I certify that I agree to the terms of the U.S.
                  Legal Attorney Agreement.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div
          v-if="caseType == 'CDL' && case_selected == 'true'"
          class="bg-white shadow overflow-hidden sm:rounded-lg mb-4"
        >
          <div class="px-4 py-5 sm:px-6">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Enter Invoice Details
            </h3>
          </div>
          <div class="border-t border-gray-200 px-4 py-5 sm:px-6">
            <div class="form-group grid grid-cols-6 gap-6 mt-2">
              <div class="col-span-6 sm:col-span-2">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px "
                  >Attorney Invoice #</label
                >
                <input
                  type="text"
                  v-model="cdl_data.invoice"
                  class="shadow-sm border-barley block w-full sm:text-sm border-gray-300 rounded-md"
                  :disabled="
                    case_details.ticket_type == 'Referral' ||
                      caseStatus == 'Closed' ||
                      caseStatus == 'In Process' ||
                      caseStatus == 'Denied'
                  "
                />
              </div>
              <div class="col-span-6 sm:col-span-2">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px "
                  >Claim Amount</label
                >
                <input
                  type="text"
                  v-model="cdl_data.claim_amount"
                  class="shadow-sm border-barley block w-full sm:text-sm border-gray-300 rounded-md"
                  :disabled="
                    case_details.ticket_type == 'Referral' ||
                      caseStatus == 'Closed' ||
                      caseStatus == 'In Process' ||
                      caseStatus == 'Denied'
                  "
                  readonly
                />
              </div>
              <div class="col-span-6 sm:col-span-2">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px "
                  >Certified Disposition Fee</label
                >
                <input
                  type="text"
                  v-model="cdl_data.certified_disposition_fee"
                  class="shadow-sm border-barley block w-full sm:text-sm border-gray-300 rounded-md"
                  :disabled="
                    case_details.ticket_type == 'Referral' ||
                      caseStatus == 'Closed' ||
                      caseStatus == 'In Process' ||
                      caseStatus == 'Denied'
                  "
                  readonly
                />
              </div>
                <div v-if="case_details.check_number != null" class="col-span-6 sm:col-span-2">
                  <label
                    class="block text-sm font-medium text-gray-700 sm:mt-px "
                    >Check Number</label
                  >
                  <input
                    type="text"
                    v-model="case_details.check_number"
                    class="shadow-sm border-barley block w-full sm:text-sm border-gray-300 rounded-md"
                    disabled
                  />
                </div>
                <div v-if="case_details.check_number != null" class="col-span-6 sm:col-span-2">
                  <label
                    class="block text-sm font-medium text-gray-700 sm:mt-px "
                    >Paid Date</label
                  >
                  <input
                    type="text"
                    v-model="case_details.check_date"
                    class="shadow-sm border-barley block w-full sm:text-sm border-gray-300 rounded-md"
                    disabled
                  />
                </div>
                <div v-if="case_details.check_number != null" class="col-span-6 sm:col-span-2">
                  <label
                    class="block text-sm font-medium text-gray-700 sm:mt-px "
                    >Paid Amount</label
                  >
                  <input
                    type="number"
                    v-model="case_details.paid_amount"
                    class="shadow-sm border-barley block w-full sm:text-sm border-gray-300 rounded-md"
                    disabled
                  />
                </div>
              <div class="col-span-6 sm:col-span-2">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px "
                  >Notes <span class="ml-1 text-red-700">*</span></label
                >
                <textarea
                  v-model="cdl_data.notes"
                  class="max-w-lg shadow-sm block w-full border-barley border-gray-300 sm:text-sm border rounded-md"
                  placeholder="Please include a brief description of services."
                  :disabled="caseStatus == 'Closed'"
                ></textarea>
              </div>
              <div class="col-span-6 sm:col-span-2">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px "
                  >Fine Due Date</label
                >
                <flat-pickr
                  v-model="cdl_data.fine_due_date"
                  :config="config"
                  class="w-full text-black border-1 border-barley border-gray-300 rounded py-2 px-4"
                  placeholder="Select date"
                >
                </flat-pickr>
              </div>

              <div
                class="col-span-6 sm:col-span-2"
                v-if="caseStatus == 'Not Closed'"
              >
                <label
                  for="cover-photo"
                  class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2 w-full mb-1"
                >
                  Upload Billing Sheet and Disposition:
                </label>
                <div
                  class="max-w-lg flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md"
                >
                  <div class="space-y-1 text-center">
                    <svg
                      class="mx-auto h-12 w-12 text-gray-400"
                      stroke="currentColor"
                      fill="none"
                      viewBox="0 0 48 48"
                      aria-hidden="true"
                    >
                      <path
                        d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <div class="flex text-sm text-gray-600">
                      <label
                        for="file"
                        class="relative cursor-pointer bg-white rounded-md font-medium cobalt-text-color hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500"
                      >
                        <span>Upload a file</span>
                        <input
                          id="file"
                          name="file"
                          type="file"
                          multiple
                          @change="uploadFile($event)"
                          class="sr-only"
                        />
                      </label>
                      <p class="pl-1">or drag and drop</p>
                    </div>
                  </div>
                </div>
               
              </div>
              <div class="col-span-6 sm:col-span-2">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px "
                  >Digital Signature (Enter Name)
                  <span class="ml-1 text-red-700">*</span></label
                >
                <input
                  type="text"
                  v-model="cdl_data.digital_sign"
                  class="shadow-sm border-barley block w-full sm:text-sm border-gray-300 rounded-md"
                  :disabled="
                    caseStatus == 'Closed' ||
                      caseStatus == 'In Process' ||
                      caseStatus == 'Denied'
                  "
                  required
                />
              </div>
              <div class="col-span-6 sm:col-span-2">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px "
                  >Date <span class="ml-1 text-red-700">*</span></label
                >
                <flat-pickr
                  v-model="cdl_data.date"
                  aria-label="Date"
                  :config="config"
                  :disabled="
                    caseStatus == 'Closed' ||
                      caseStatus == 'In Process' ||
                      caseStatus == 'Denied'
                  "
                  class="w-full text-black border-1 border-barley border-gray-300 rounded py-2 px-4"
                  placeholder="Select date"
                >
                </flat-pickr>
              </div>
              <div class="col-span-6 sm:col-span-2">
               <div class="" v-if="pdfFile?.length > 0">
                  <div class="" v-for="(file, i) in pdfFile" :key="i">
                    <div class="py-5 px-3">
                      <div class="float-left mr-2" align="center">
                        <img src="@/assets/Images/file-pdf.png" />
                      </div>
                      <div class="float-left w-100">
                        <span class="">{{ file.name }}</span>
                      </div>
                    </div>
                    <br />
                    <hr />
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-4" v-show="caseStatus == 'Not Closed'">
              <button
                type="button"
                @click="addPayment()"
                class="mt-3
                      w-full
                      inline-flex
                      items-center
                      justify-center
                      px-4
                      py-2
                      border border-transparent
                      shadow-sm
                      font-medium
                      rounded-md
                      text-white
                    cobalt-button-color
                      focus:outline-none
                      focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500
                      sm:mt-0
                      sm:ml-3
                      sm:w-auto
                      sm:text-sm"
              >
                Submit Claim
              </button>
              <button
                type="button"
                @click="reset()"
                class="mt-3 w-full inline-flex items-center justify-center px-4 py-2 border border-transparent shadow-sm font-medium rounded-md text-white bg-yellow-600 hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
              >
                Clear
              </button>
            </div>
            <div
              class="barley-corn-bg-color-2 border-l-4 cobalt-border-color-2 p-4 text-white m-2"
            >
              <ul class="list-disc ml-3">
                <li>
                  <b>ATTORNEY'S DIGITAL SIGNATURE: </b>Attorney acknowledges
                  that he/she has contacted U.S. Legal Services to ascertain the
                  plan benefits available to the Member and obtained the
                  appropriate authorization for legal services rendered prior to
                  submitting this claim. Claims submitted without proper
                  authorization may be subject to denial.
                </li>
                <li>
                  Claims must be submitted within ninety [90] days following the
                  completion of any legal matter for which services have been
                  rendered. Claims submitted more than ninety [90] days after
                  matter completion may be subject to denial. Completed claims
                  (that include proper documentation) will be paid within two
                  weeks.
                </li>
                <li>
                  Claim Fraud Warning Statement: Any person who, with intent to
                  defraud or knowing that he or she is facilitating a fraud
                  against an insurer, submits an application or files a claim
                  containing a false or deceptive statement, may be guilty of
                  insurance fraud.
                </li>
                <li>
                  By submitting this claim, I attest to the accuracy of the
                  information submitted and agree to provide additional
                  information necessary to adjudicate this claim. By submitting
                  this claim I certify that I agree to the terms of the U.S.
                  Legal Attorney Agreement.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="showPopup" class="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-white p-6 rounded-lg shadow-lg max-w-lg w-full">
        <h1 class="text-center text-2xl font-semibold mb-4" style="color: #1f3341;">
          2025 Fee for Services Network Attorney Agreement
        </h1>
        <p class="text-gray-800 font-bold">
          We’re excited to share that U.S. Legal Services has updated and enhanced our Attorney Fee Reimbursement Schedule—designed with you in mind to offer greater overall compensation for the valuable work you do.<br />
          <br />
          The new schedule goes into effect on June 9, 2025. Please note that any matters authorized before that date will be paid based on the prior fee schedule, while all matters assigned and authorized on or after June 9 will follow the updated rates outlined in the below link.<br />
          <br />
          Please click the following link to review and sign the new Fee for Services Network Attorney Agreement and Fee Schedule:
          <a  href="#"
          @click.prevent="handleFeeAgreementClick"
          class="text-blue-600 hover:underline">Click here</a>
        </p>
        <button @click="dismissPopup" class="mx-auto px-4 py-2 bg-[#1f3341] text-white rounded-lg hover:bg-[#1f3341] block">Close</button>
      </div>
    </div>
</template>

<script>
import Constants from "../../constants.ts"; // importing constant resubale variables.
import { mapState } from "vuex"; // importing mapState for get access state level variables.
import moment from "moment-timezone";
import $ from "jquery";
import { checkFeeAgreementStatus, generateDynamicLink } from '@/utils/feeAgreementPopup';

export default {
  name: "ClaimList",
  data() {
    return {
      showPopup: false,
      disposition_codes: null,
      setDateFormat: Constants.setDateFormat,
      config: {
        wrap: true,
        altFormat: "M j, Y",
        altInput: true,
        dateFormat: "Y-m-d",
        onReady: (_selectedDates, _dateStr, instance) => {
          const original = instance?.input;
          const visible = instance?.altInput || instance?.input;
          if (!visible) return;

          // When altInput is enabled, Flatpickr keeps a hidden "original" input
          // and creates a visible readonly input (altInput). Move labeling to the visible one.
          if (original && original !== visible) {
            const ariaLabel = original.getAttribute("aria-label");
            const ariaLabelledBy = original.getAttribute("aria-labelledby");

            if (ariaLabel) visible.setAttribute("aria-label", ariaLabel);
            if (ariaLabelledBy) visible.setAttribute("aria-labelledby", ariaLabelledBy);

            original.removeAttribute("aria-label");
            original.removeAttribute("aria-labelledby");
            original.setAttribute("aria-hidden", "true");
          }
        },
      },
      paymentDateConfig: {
        wrap: true,
        altFormat: "M j, Y",
        altInput: true,
        dateFormat: "Y-m-d",
        onReady: (_selectedDates, _dateStr, instance) => {
          const el = instance?.altInput || instance?.input;
          if (!el) return;
          el.id = "payment_date_input";
          el.setAttribute("aria-labelledby", "payment_date_label");
        },
      },
      pdfFile: [],
      caseList: {},
      matter_data: {},
      caseType: "Matter",
      caseStatus: "Not Closed",
      caseNumber: null,
      payment_date: null,
      check_number: null,
      member: null,
      currentAttorney: null,
      case_selected: null,
      matter_case_list: {},
      case_details: {},
      file_upload_flag: false,
      new_claim_flag: null,
      matter_save_btn: true,
      disposition_flag: null,
      save_flag: null,
      search_screen_flag: "false",
      claim_details: [],
      claim_files: {
            "business_registration" : {"label":"Business Registration","prefix":"BUSR"},
            "copy_of_disposition" : {"label":"Copy of Disposition","prefix":"CDSP"},
            "copy_of_docket" : {"label":"Copy of Docket","prefix":"CDOC"},
            "Copy_of_the_docket" : {"label":"Copy of the Docket","prefix":"CDOC"},
            "demand_letter" : {"label":"Demand Letter","prefix":"DLET"},
            "Detailed_billing_invoice" : {"label":"Detailed Billing Invoice","prefix":"DINV"},
            "document_executed_sign" : {"label":"Document Executed Sign","prefix":"DSIG"},
            "executed_application" : {"label":"Executed Application","prefix":"EAPP"},
            "executed_pre_nuptial" : {"label":"Executed Pre Nuptial","prefix":"PNUP"},
            "final_judgment_order" : {"label":"Final Judgment Order","prefix":"JORD"},
            "hearing_notice" : {"label":"Hearing Notice","prefix":"HNOT"},
            "meeting_of_creditors" : {"label":"Meeting of Creditors","prefix":"MCRE"},
            "signed_members_acknowledgement" : {"label":"Signed Members Acknowledgement","prefix":"MACK"},
            "other_file" : {"label":"Other File","prefix":"OTHR"},
            "copy_of_the_341_Meeting_of_Creditors" : {"label":"Copy of the 341 Meeting of Creditors","prefix":"M341"},
            "Copy_of_the_final_judgment": {"label":"Copy of the Final Judgment","prefix":"CFJ1"},
            "Copy_of_the_hearing_notice": {"label":"Copy of the Hearing Notice","prefix":"CHN1"},
            "Copy_of_the_filed_business_registration": {"label":"Copy of the Filed Business Registration","prefix":"CBR1"},
            "Copy_of_the_demand_letter": {"label":"Copy of the Demand Letter","prefix":"CDL1"},
            "Copy_of_the_final_disposition": {"label":"Copy of the Final Disposition","prefix":"CFD1"},
            "Signed_page_of_the_executed_documents": {"label":"Signed Page of the Executed Documents","prefix":"SPED"},
            "Copy_of_the_final_judgment_from_the_court": {"label":"Copy of the Final Judgment from the Court","prefix":"CFJC"},
            "Copy_of_the_executed_application_Form_N400": {"label":"Copy of the Executed Application Form N400","prefix":"N400"},
            "Copy_of_the_disposition": {"label":"Copy of the Disposition","prefix":"CDIS"},
            "Copy_of_the_docket_or_drafted_documents_if_the_case_has_not_yet_been_filed": {"label":"Copy of the Docket or Drafted Documents (If Case Not Filed)","prefix":"CDDF"},
            "Copy_of_the_drafted_agreement": {"label":"Copy of the Drafted Agreement","prefix":"CDAG"},
            "Copy_of_the_closing_statement": {"label":"Copy of the Closing Statement","prefix":"CCLS"},
            "Member_Acknowledgment_of_Services_Rendered_Form": {"label":"Member Acknowledgment of Services Rendered Form","prefix":"MASR"},
            "Copy_of_the_document": {"label":"Copy of the Document","prefix":"CDOC2"},
            "Copy_of_the_first_and_last_page_of_the_final_disposition": {"label":"Copy of First & Last Page of Final Disposition","prefix":"CFLD"},
            "Copy_of_settlement": {"label":"Copy of Settlement","prefix":"CSET2"},
            "closing_statement": {"label":"Closing Statement","prefix":"CLST"},
            "Copy_of_the_first_and_last_page_of_the_final_order_or_judgment_or_disposition": {"label":"Copy of First & Last Page of Final Order/Judgment/Disposition","prefix":"CFLO"},
            "Copies_of_emails_or_other_correspondence_with_the_member_or_opposing_party_negotiations": {"label":"Copies of Emails/Correspondence with Member/Opposing Party","prefix":"CEML"},
            "Copies_of_correspondence_and_negotiations_with_the_landlord": {"label":"Copies of Correspondence with Landlord","prefix":"CLND"},
            "Copy_of_the_drafted_document": {"label":"Copy of the Drafted Document","prefix":"CDRD"},
            "Letters_of_Guardianship_or_Conservatorship": {"label":"Letters of Guardianship/Conservatorship","prefix":"LGCS"},
            "Correspondence_related_to_the_services_provided": {"label":"Correspondence Related to Services Provided","prefix":"CRSP"}
        }
    };
  },
  components: {},
  async mounted() {
    const attid = this.attid || this.$store.state.profile_data.attid;
    const isSelected = await checkFeeAgreementStatus(this.$store);
    const dismissed = localStorage.getItem('feeAgreementPopupDismissed');
    this.showPopup = !isSelected && !dismissed;
    this.dynamicLink = await generateDynamicLink(attid);
    $("body, html").animate({ scrollTop: 0 }, 1000);
    this.currentAttorney = JSON.parse(localStorage.getItem("att_data"));
    this.search();
    this.fixPaginatorA11y();
    this.startPaginatorA11yObserver();
    this.$store.dispatch("getDisposition").then((response) => {
      console.log("response", response.data.data);
      this.disposition_codes = response.data.data;
    });
  },
  beforeUnmount() {
    this.stopPaginatorA11yObserver();
  },
  watch: {
    case_list() {
      this.fixPaginatorA11y();
    },
  },
  computed: {
  ...mapState(["case_list", "cdl_case_list"]),
  attid() {
      return this.$store._state.data.att_user.data.id;
    },
  },
  methods: {
    startPaginatorA11yObserver() {
      this.stopPaginatorA11yObserver();
      this.$nextTick(() => {
        const root = this.$el;
        if (!root || typeof MutationObserver === "undefined") return;
        this._paginatorA11yObserver = new MutationObserver(() => {
          this.fixPaginatorA11y();
        });
        this._paginatorA11yObserver.observe(root, {
          childList: true,
          subtree: true,
        });
      });
    },
    stopPaginatorA11yObserver() {
      if (this._paginatorA11yObserver) {
        this._paginatorA11yObserver.disconnect();
        this._paginatorA11yObserver = null;
      }
    },
    fixPaginatorA11y() {
      this.$nextTick(() => {
        const root = this.$el;
        if (!root || !root.querySelectorAll) return;

        const pageButtonLabels = {
          "p-paginator-first": "First page",
          "p-paginator-prev": "Previous page",
          "p-paginator-next": "Next page",
          "p-paginator-last": "Last page",
        };

        root.querySelectorAll(".p-paginator button").forEach((btn) => {
          for (const [cls, label] of Object.entries(pageButtonLabels)) {
            if (btn.classList.contains(cls)) {
              btn.setAttribute("aria-label", label);
              const icon = btn.querySelector(".p-paginator-icon");
              if (icon) icon.setAttribute("aria-hidden", "true");
              return;
            }
          }
        });

        root
          .querySelectorAll(
            ".p-paginator .p-dropdown .p-hidden-accessible input, .p-paginator .p-dropdown input[readonly]"
          )
          .forEach((input) => {
            input.setAttribute("role", "combobox");
            input.setAttribute("aria-haspopup", "listbox");
            input.setAttribute("aria-label", "Rows per page");
            input.removeAttribute("aria-labelledby");
          });

        root.querySelectorAll(".p-paginator .p-dropdown-trigger").forEach((el) => {
          if (!el.getAttribute("aria-label")) {
            el.setAttribute("aria-label", "Rows per page");
          }
          const icon = el.querySelector(".p-dropdown-trigger-icon, .pi");
          if (icon) icon.setAttribute("aria-hidden", "true");
        });
      });
    },
    dismissPopup() {
    this.showPopup = false;
    localStorage.setItem('feeAgreementPopupDismissed', 'true');
  },
    handleFeeAgreementClick() {

      // setTimeout(() => {
        // this.logoutUser();
        this.$store.dispatch("logout");

        // window.open(this.dynamicLink);
        window.location.href = this.dynamicLink;
      // }, 500);
    },
    search() {
      this.pdfFile = [];
      this.claim_details = {};
      this.matter_data = {};
      this.case_details = {};
      this.case_selected = false;
      console.log("this.currentAttorney", this.currentAttorney.data.id);
      //return false;
      this.$store.dispatch("getCaseList", {
        status: this.caseStatus,
        case_number: this.caseNumber,
        check_number: this.check_number,
        check_date : this.payment_date, 
        case_type: this.caseType,
        attorney_id: this.currentAttorney.data.id,
        member_id: this.member,
      }).then((result) => {
          console.log(result);
          this.fixPaginatorA11y();
        })
        .catch((error) => {
          if (error.status == "Failed") {
            this.$toast.error(
              "Authorization Token Expired, Please login again!"
            );
            this.$store.dispatch("logout");
            this.$router.push("login");
          }
        });
      if (this.caseNumber || this.member) {
        this.search_screen_flag = "true";
        this.caseNumber = "";
      } else {
        this.search_screen_flag = "false";
      }
    },
    getCasedetails(case_number, case_type, claim_id, auth_id, ap_id) {
      console.log(case_type);
      this.claim_details = {};
      this.cdl_data = {};
      this.case_selected = "true";
      this.matter_data = {};
      if (case_type == "CDL") {
        this.$store
          .dispatch("getCDLCasedetails", {
            case_number: case_number,
          })
          .then((response) => {
            console.log(response)
            if (response.data[0].status == "Success") {
              this.case_details = response.data[0].data[0];
              console.log(
                "this.case_details.violations",
                this.case_details.violations
              );
              this.case_details.violations.forEach((value) => {
                if (!value.total_due_amount) {
                  value.total_due_amount = 0;
                } else {
                  value.total_due_amount = parseFloat(value.total_due_amount).toFixed(2);
                }
                if (!value.final_court_cost_due) {
                  value.final_court_cost_due = 0;
                } else {
                  value.final_court_cost_due = parseFloat(value.final_court_cost_due).toFixed(
                    2
                  );
                }
                if (!value.disposition) {
                  value.disposition = null;
                }
                value.final_total_due_driver =
                  value.total_due_amount +
                  value.final_court_cost_due;
              });
              this.case_details.denied_reason = JSON.parse(
                this.case_details.denied_reason
              );
              this.case_selected = "true";
              this.case_type = "CDL";
              this.cdl_data.invoice = this.case_details.attorney_invoice_claim;

              if (
                this.case_details.certified_disposition_fee == null ||
                this.case_details.certified_disposition_fee == ""
              ) {
                this.cdl_data.certified_disposition_fee = parseFloat(
                  this.case_details.cdl_certified_disposition_fee
                );
              } else {
                this.cdl_data.certified_disposition_fee = this.cdl_data.certified_disposition_fee = parseFloat(
                  this.case_details.certified_disposition_fee
                );
              }
              this.cdl_data.claim_amount = parseFloat(
                this.case_details.attorney_fee
              );
              this.cdl_data.notes = this.case_details.Note;
              if (
                this.case_details.fine_due_date == "" ||
                this.case_details.fine_due_date == null
              ) {
                if (
                  this.case_details.cdl_c_fine_due_date != "" &&
                  this.case_details.cdl_c_fine_due_date != null
                ) {
                  this.cdl_data.fine_due_date = moment(
                    this.case_details.cdl_c_fine_due_date
                  ).format("MM/DD/YYYY");
                  this.cdl_data.fine_due_date = new Date(
                    this.case_details.cdl_c_fine_due_date
                  );
                } else {
                  this.cdl_data.fine_due_date = "";
                }
              } else {
                if (
                  this.case_details.fine_due_date != "" &&
                  this.case_details.fine_due_date != null
                ) {
                  this.cdl_data.fine_due_date = moment(
                    this.case_details.fine_due_date
                  ).format("MM/DD/YYYY");
                  this.cdl_data.fine_due_date = new Date(
                    this.case_details.fine_due_date
                  );
                } else {
                  this.cdl_data.fine_due_date = "";
                }
              }
              this.cdl_data.date = moment(
                this.case_details.claim_tool_date
              ).format("MM/DD/YYYY");
              this.cdl_data.county_civil_criminal = this.case_details.county_civil_criminal;
              this.cdl_data.digital_sign = this.case_details.attorney_digital_signature;
            } else {
              console.log("ELSE");
            }
          });
      } else {
        this.$store
          .dispatch("getMatterCasedetails", {
            case_number: case_number,
            claim_id: claim_id,
            auth_id: auth_id,
            ap_id: ap_id,
          })
          .then((response) => {
            console.log("response", response);
            //this.matter_case_list = response.data[0].data;
            console.log(response.data[0].data[0]);
            this.case_details = response.data[0].data[0];
            this.claim_details = response.data[0].data["claim_data"];
            if (
              this.case_details.sub_coverage ==
              "II. advice and review/consultation services"
            ) {
              this.file_upload_flag = false;
            } else {
              this.file_upload_flag = true;
            }
            this.case_selected = "true";
            this.matter_data = this.case_details;
            this.matter_data.date = new Date();
            this.matter_data.claim_amount = parseFloat(
              this.case_details.claim_amount
            );
            this.matter_data.claim_hours = parseFloat(
              this.case_details.claim_hours
            );
            this.matter_data.paid_amount = parseFloat(
              this.case_details.paid_amount
            );
            if (
              this.matter_data.claim_type == "claim_amount_less_then_auth" &&
              this.caseStatus == "Not Closed"
            ) {
              if (
                this.matter_data.payment_date != "" &&
                this.matter_data.payment_date != null
              ) {
                this.matter_data.payment_date = moment(
                  this.matter_data.payment_date
                ).format("MM/DD/YYYY");
                this.matter_data.payment_date = new Date(
                  this.matter_data.payment_date
                );
              }
              if (
                this.matter_data.date_of_last_service != "" &&
                this.matter_data.date_of_last_service != null
              ) {
                this.matter_data.date_of_last_service = moment(
                  this.matter_data.date_of_last_service
                ).format("MM/DD/YYYY");
                this.matter_data.date_of_last_service = new Date(
                  this.matter_data.date_of_last_service
                );
              }
              this.matter_data.attorney_invoice_claim = "";
              this.matter_data.claim_amount = "";
              this.matter_data.claim_hours = "";
              this.matter_data.note = "";
              this.matter_data.digital_sign = "";
              this.new_claim_flag = "true";
              //this.set_cliam_desc_lbl(this.case_details.m_coverage);
            } else {
              this.new_claim_flag = "false";
              /* if(this.matter_data.payment_date !='' && this.matter_data.payment_date != null){
								
									this.matter_data.payment_date =moment(this.matter_data.payment_date).format("MM/DD/YYYY");
									this.matter_data.payment_date = new Date(this.matter_data.payment_date);							
								}
								if(this.matter_data.date_of_last_service !='' && this.matter_data.date_of_last_service != null){
									this.matter_data.date_of_last_service =moment(this.matter_data.date_of_last_service).format("MM/DD/YYYY"); 
                  this.matter_data.date_of_last_service = new Date(this.matter_data.date_of_last_service);							
								} */
              if (
                this.matter_data.claim_tool_date != "" &&
                this.matter_data.claim_tool_date != null
              ) {
                this.matter_data.date = this.matter_data.claim_tool_date;
              }

              this.matter_data.digital_sign = this.case_details.attorney_digital_signature;
              if (this.matter_data.status != "Closed") {
                this.matter_data.case_status = "Open";
              } else {
                this.matter_data.case_status = "Closed";
              }
              console.log(this.matter_data);
              //this.set_cliam_desc_lbl(this.case_details.m_coverage);
            }
            this.matter_data.claim_miles = this.case_details.authorized_miles;

          });
      }

      console.log("case_number", case_number);
      console.log("case_type", case_type);
      console.log("claim_id", claim_id);
      console.log("auth_id", auth_id);
      console.log("ap_id", ap_id);
    },
    /* set_cliam_desc_lbl(){
      this.claim_desc = claim_desc;
      this.claim_desc.forEach(element => {
        console.log(element);
        // if(value.key==cov){
        //   this.claim_desc_lbl =value.value;	
        // }
      });
    },
     */
    pad(n, width, z) {
      z = z || "0";
      n = n + "";
      return n.length >= width
        ? n
        : new Array(width - n.length + 1).join(z) + n;
    },
    uploadMatterFiles(e,fileKey,prefix) {
      var files = e.target.files || e.dataTransfer.files;
      if (files.length>0) {
        if (files.length > 6) {
          this.$toast.error("Please Select File Less Then Six");
        }
        for (let index = 0; index < files.length; index++) {
          const value = files[index];
          if (value.type != "application/pdf") {
              this.$toast.error("Only PDF file is allowed");
            } else {
              if (this.pdfFile?.some((el) => el.name == value.name)) {
                this.$toast.error("Duplicate file can not be allowed.");
              } else {
                if(prefix){
                  value.prefix = prefix;
                }
                if (!this.claim_files || !this.claim_files[fileKey] || !this.claim_files[fileKey].files) {
                  if (!this.claim_files) {
                    this.claim_files = {};
                  }
                  if (!this.claim_files[fileKey]) {
                    this.claim_files[fileKey] = {};
                  }
                  this.claim_files[fileKey].files = [];
                }

                this.claim_files[fileKey].files.push(prefix + '-' + value.name);
                this.pdfFile.push(value);
              }
            }
        }
      }
      console.log(this.pdfFile);
    },
    uploadFile(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (files.length>0) {
        if (files.length > 6) {
          this.$toast.error("Please Select File Less Then Six");
        }
        for (let index = 0; index < files.length; index++) {
          const value = files[index];
          if (value.type != "application/pdf") {
            this.$toast.error("Only PDF file is allowed");
          } else {
            if (this.pdfFile?.some((el) => el.name == value.name)) {
              this.$toast.error("Duplicate file can not be allowed.");
            } else {
              this.pdfFile.push(value);
            }
          }
        }
      }
    },
    addPayment() {
      //alert(this.caseType);
      console.log("matter_data", this.matter_data);
      var disposition_flag = false;
      this.matter_save_btn = false;
      this.save_flag = false;
      if (this.caseType == "Matter") {
        this.matter_data.claim_number =
          "2" +
          String(this.pad(Math.floor(Math.random() * 99) + parseInt("01"), 2)) +
          String(
            this.pad(
              Math.floor(Math.random() * parseInt("999999")) + parseInt("01"),
              6
            )
          );
        for (var key in this.claim_files) {
            if(this.case_details){
              if(this.case_details[key]?.required == true){
                console.log(this.claim_files[key]);
                if(this.claim_files[key] && (!this.claim_files[key].files || this.claim_files[key].files.length == 0)){
                  this.$toast.error("Please upload required claim file.");
                  this.matter_save_btn = true;
                  return false;
                }
              }
            }
        }
        if (
          this.matter_data.payment_date == "" ||
          this.matter_data.payment_date == null
        ) {
          this.$toast.error("Please Select Member First Contact Date");
          this.matter_save_btn = true;
          return false;
        } else if (
          this.matter_data.claim_amount == "" ||
          this.matter_data.claim_amount == null ||
          isNaN(this.matter_data.claim_amount)
        ) {
          this.$toast.error("Please enter a valid claim amount");
          this.matter_save_btn = true;
          return false;
        } else if (
          this.matter_data.date_of_last_service == "" ||
          this.matter_data.date_of_last_service == null
        ) {
          this.$toast.error("Please Select Date of Last Service");
          this.matter_save_btn = true;
          return false;
        } else if (
          this.matter_data.digital_sign == "" ||
          this.matter_data.digital_sign == null
        ) {
          this.$toast.error("Please Enter Digital Signature");
          this.matter_save_btn = true;
          return false;
        } else if (
          this.matter_data.date == "" ||
          this.matter_data.date == null
        ) {
          this.$toast.error("Please Select Date");
          this.matter_save_btn = true;
          return false;
        } else if (
          this.matter_data.note == "" ||
          this.matter_data.note == null
        ) {
          this.$toast.error("Please Enter Notes");
          this.matter_save_btn = true;
          return false;
        } 
        // else if (
        //   this.pdfFile.length <=0
        // ) {
        //   if(this.case_details.sub_coverage!="II. advice and review/consultation services"){
        //     this.$toast.error("Please upload required files");
        //     this.matter_save_btn = true;
        //     return false;
        //   }
        // }

      } else {
        var notes = this.cdl_data.notes;
        //var cdl_date = $filter('date')(this.cdl_data.date, 'MMM dd yyyy');
        var cdl_date = moment(this.cdl_data.date).format("MMM dd yyyy");
        if (notes == "" || notes == null || notes == undefined) {
          this.$toast.error("Please Enter Notes");
          this.save_flag = true;
          return false;
        }
        if (typeof cdl_date === "object" || typeof cdl_date === undefined) {
          this.$toast.error("Please Enter Date");
          this.save_flag = true;
          return false;
        }

        // angular.forEach(this.case_details.violations, function(value, key) {
        //   if(value.disposition == '' || value.disposition == null){
        //     //SweetAlert.swal("Invalid Input", "Please Select Disposition", "error");
        //     this.save_flag = true;
        //       disposition_flag = true;
        //       return false;
        //   }
        // });
        //return false // temporary
      }
      console.log(disposition_flag);
      if (disposition_flag) {
        return false;
      }
      if (this.matter_data) {
        console.log("Hello");
        this.matter_data.payment_date = moment(
          this.matter_data.payment_date
        ).format("MM/DD/YYYY");
        this.matter_data.date_of_last_service = moment(
          this.matter_data.date_of_last_service
        ).format("MM/DD/YYYY");
        this.matter_data.date = moment(this.matter_data.date).format(
          "MM/DD/YYYY"
        );
      }

      let file_list = [];
      this.pdfFile.forEach((value) => {
        file_list.push(value.name);
      });
      this.data = {
        case_details: this.case_details,
        cdl_data: this.cdl_data,
        matter_data: this.matter_data,
        pdfFile: file_list,
      };
      console.log(this.data);

      this.$store
        .dispatch("CreateClaim", {
          data: this.data,
        })
        .then((result) => {
          console.log(result);
          //file upload code start
          const formData = new FormData();
          for (let index = 0; index < this.pdfFile.length; index++) {
            formData.append("files[]", this.pdfFile[index]);
            formData.append("prefix[]", this.pdfFile[index].prefix);
          }
          
          if (this.caseType == "Matter") {
            formData.append("claim_id", result.data.data.claim_id);
            formData.append("claim_number", result.data.data.claim_number);
            this.$store
              .dispatch("uploadMatterClaimFile", formData)
              .then((result) => {
                console.log(result);
                this.pdfFile = [];
              })
              .catch((error) => {
                this.$toast.error("Something went wrong, please try again!");
                console.log("error: ", error);
              });
          } else {
            formData.append("claim_id", result.data.data.claim_id);
            this.$store
              .dispatch("uploadCDLClaimFile", formData)
              .then((result) => {
                this.pdfFile = [];
                console.log(result);
              })
              .catch((error) => {
                this.$toast.error("Something went wrong, please try again!");
                console.log("error: ", error);
              });
          }
          //file upload code end
          this.$toast.success("Claim created successfully");
          this.matter_data = {};
          this.cdl_data = {};
          this.caseStatus="In Process";
          this.search();
          this.matter_save_btn=true;
        })
        .catch((error) => {
          if (error.status == "Failed") {
            this.$toast.error(
              "Authorization Token Expired, Please login again!"
            );
            this.$store.dispatch("logout");
            this.$router.push("login");
          } else {
            this.$toast.error("Something went wrong, please try again!");
          }
          console.log("error: ", error);
        });
    },
    reset() {
      this.caseType = "Matter";
      this.caseStatus = "Not Closed";
      this.caseNumber = null;
      this.check_number = null;
      this.payment_date = null;
      this.member = null;
    },
  },
};
</script>
